import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import LoginPage from './pages/login/LoginPage';
import RegisterPage from './pages/register/RegisterPage';
import RegisterSuccessPage from './pages/register/RegisterSuccessPage';
import RequestResetPasswordPage from './pages/request_reset_password/RequestResetPasswordPage';
import SetPasswordPage from './pages/request_reset_password/SetPasswordPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ProjectsPage from './pages/projects/ProjectsPage';
import ProjectDetailPage from './pages/project_detail/ProjectDetailPage';
import MixedUseProjectDetailPage from './pages/mixed_use_project_detail/MixedUseProjectDetailPage';
import BuildingDetailPage from './pages/buildings/BuildingDetailPage';
import MaterialOpaquePage from './pages/material_opaque/MaterialOpaquePage';
import MaterialTransparentPage from './pages/material_transparent/MaterialTransparentPage';
import ComponentOpaquePage from './pages/component_opaque/ComponentOpaquePage';
import ComponentTransparentPage from './pages/component_transparent/ComponentTransparentPage';
import NotFoundPage from './pages/notfound/NotFoundPage';

import LuminairesPage from './pages/luminaire/LuminairesPage';
import BallastsPage from './pages/ballast/BallastsPage';
import LightingSetsPage from './pages/lighting_set/LightingSetsPage';
import ACSplitTypePage from './pages/ac_split_type/ACSplitTypePage';
import VRFIndoorPage from './pages/vrf/VRFIndoorPage';
import VRFOutdoorPage from './pages/vrf/VRFOutdoorPage';
import ACPackagedUnitPage from './pages/ac_packaged_unit/ACPackagedUnitPage';
import BoilerPage from './pages/boiler/BoilerPage';
import HeatPumpPage from './pages/heat_pump/HeatPumpPage';
import SolarEnergyPage from './pages/renewable_energy/SolarEnergyPage';
import HeatToElectricalEnergyPage from './pages/renewable_energy/HeatToElectricalEnergyPage';
import OtherRenewableEnergyPage from './pages/renewable_energy/OtherRenewableEnergyPage';
import OtherEquipmentPage from './pages/other_equipment/OtherEquipmentPage';
import ACCentralUnitPage from './pages/ac_central_unit/ACCentralUnitPage';
import ChillerPage from './pages/ac_central_unit/ChillerPage';
import WaterPumpPage from './pages/ac_central_unit/WaterPumpPage';
import CoolingTowerPage from './pages/ac_central_unit/CoolingTowerPage';
import AirHandlingUnitPage from './pages/ac_central_unit/AirHandlingUnitPage';
import FloorDetailPage from './pages/floor/FloorDetailPage';
import ZoneDetailPage from './pages/zone/ZoneDetailPage';
import EnvelopDetailPage from './pages/envelop/EnvelopDetailPage';
import ACPackagedSubPage from './pages/ac_packaged_unit/ACPackagedSubPage';
import SectionDetailPage from './pages/section/SectionDetailPage';
import ProjectInspectionPage from './pages/project_inspection/ProjectInspectionPage';
import ProjectInspectionDetailPage from './pages/project_inspection_detail/ProjectInspectionDetailPage';
import InspectionDashboardPage from './pages/inspection_dashboard/InspectionDashboardPage';
import StatisticPage from './pages/statistic/StatisticPage';
import ExecutiveDashboardPage from './pages/executive_dashboard/ExecutiveDashboardPage';
import FormWizardPage from './pages/forms/FormWizardPage';

import AppNavbar from './components/appnavbar/AppNavbar';
import AppInspectorNavbar from './components/appnavbar/AppInspectorNavbar';
import { Button } from 'react-bootstrap';

const GlobalError = props => {
  const containerStyle = {
    width: '100%',
    height: 40,
    position: 'fixed',
    top: 0,
    zIndex: 2000,
  };

  const bgStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: 'red',
    opacity: 0.8,
  };

  const textStyle = {
    flex: 1,
    textAlign: 'center',
    color: 'white',
    alignSelf: 'center',
  };

  return (
    <div style={containerStyle}>
      <div style={bgStyle}>
        <span style={textStyle}>{props.message}</span>
        <Button
          style={{ color: 'white' }}
          bsStyle="link"
          onClick={() => props.onHide()}
        >
          {props.t('close')}
        </Button>
      </div>
    </div>
  );
};

const router = props => {
  const {
    loggedIn = false,
    isInspector,
    isNetworkError,
    onGlobalErrorHide,
    isShowSideMenu,
    t,
  } = props;
  if (loggedIn) {
    const routers = [
      { path: '/dashboard', component: DashboardPage },
      { path: '/projects/:projectId/forms', component: FormWizardPage },
      { path: '/projects/:projectId', component: ProjectDetailPage },
      {
        path: '/projects/mixeduse/:projectId',
        component: MixedUseProjectDetailPage,
      },
      { path: '/projects', component: ProjectsPage },
      { path: '/buildings/:buildingId', component: BuildingDetailPage },
      { path: '/materials/opaque', component: MaterialOpaquePage },
      { path: '/materials/transparent', component: MaterialTransparentPage },
      { path: '/components/opaque', component: ComponentOpaquePage },
      { path: '/components/transparent', component: ComponentTransparentPage },
      { path: '/lighting/luminaire', component: LuminairesPage },
      { path: '/lighting/ballast', component: BallastsPage },
      { path: '/lighting/lighting_set', component: LightingSetsPage },
      { path: '/ac/split_type', component: ACSplitTypePage },
      { path: '/ac/vrf_indoor', component: VRFIndoorPage },
      { path: '/ac/vrf_outdoor', component: VRFOutdoorPage },
      { path: '/ac/packaged_unit', component: ACPackagedUnitPage },
      { path: '/ac/packaged/packaged_sub', component: ACPackagedSubPage },
      { path: '/ac/central', component: ACCentralUnitPage },
      { path: '/ac/central/chiller', component: ChillerPage },
      { path: '/ac/central/water_pump', component: WaterPumpPage },
      { path: '/ac/central/cooling_tower', component: CoolingTowerPage },
      { path: '/ac/central/air_handling_unit', component: AirHandlingUnitPage },
      { path: '/hot_water_system/boiler', component: BoilerPage },
      { path: '/hot_water_system/heat_pump', component: HeatPumpPage },
      { path: '/renewable_energy/solar_energy', component: SolarEnergyPage },
      {
        path: '/renewable_energy/heat_to_electrical_energy',
        component: HeatToElectricalEnergyPage,
      },
      {
        path: '/renewable_energy/other_renewable_energy',
        component: OtherRenewableEnergyPage,
      },
      { path: '/other_equipments', component: OtherEquipmentPage },
      { path: '/floors/:floorId', component: FloorDetailPage },
      { path: '/zones/:zoneId', component: ZoneDetailPage },
      { path: '/sections/:sectionId', component: SectionDetailPage },
      {
        path: '/envelops/:envelopId/:envelopType',
        component: EnvelopDetailPage,
      },
      { path: '/project_inspections', component: ProjectInspectionPage },
      {
        path: '/project_inspections/:id',
        component: ProjectInspectionDetailPage,
      },
      { path: '/inspection_dashboard', component: InspectionDashboardPage },
      { path: '/executive_dashboard', component: ExecutiveDashboardPage },
      { path: '/statistics', component: StatisticPage },
    ];
    const redirectPath = isInspector ? '/inspection_dashboard' : '/dashboard';
    return (
      <BrowserRouter>
        <div className="application-row">
          {isNetworkError && (
            <GlobalError
              t={t}
              message={t('network error')}
              onHide={() => onGlobalErrorHide()}
            />
          )}
          {isInspector ? (
            <AppInspectorNavbar isShow={isShowSideMenu} />
          ) : (
            <AppNavbar isShow={isShowSideMenu} />
          )}
          <Switch>
            {routers.map(({ path, component }) => (
              <Route key={path} exact path={path} component={component} />
            ))}
            <Route
              exact
              path="/"
              render={() => <Redirect to={redirectPath} />}
            />
            <Route component={NotFoundPage} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  } else {
    const routers = [
      { path: '/', component: LoginPage },
      { path: '/register', component: RegisterPage },
      { path: '/register/success', component: RegisterSuccessPage },
      { path: '/request_reset_password', component: RequestResetPasswordPage },
    ];
    const redirectPath = '/';
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route
              exact
              path="/change_password/:id/:token"
              children={props => {
                const {
                  match: { params },
                } = props;
                return (
                  <SetPasswordPage
                    uid={params.id}
                    token={params.token}
                    {...props}
                  />
                );
              }}
            />
            {routers.map(({ path, component }) => (
              <Route key={path} exact path={path} component={component} />
            ))}
            <Route
              exact
              path="/"
              render={() => <Redirect to={redirectPath} />}
            />
            <Route component={LoginPage} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
};

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  isInspector: state.authentication.isInspector,
  isShowSideMenu: state.app.isShowSideMenu,
});

export default connect(
  mapStateToProps,
  null,
)(translate('translations')(router));



// WEBPACK FOOTER //
// ./src/Router.js